export default __webpack_public_path__ + "static/media/frame-3.e4e4876e.png";